import { render } from "./CustomizationProductImage.vue?vue&type=template&id=64556dae&scoped=true"
import script from "./CustomizationProductImage.vue?vue&type=script&lang=js"
export * from "./CustomizationProductImage.vue?vue&type=script&lang=js"

import "./CustomizationProductImage.vue?vue&type=style&index=0&id=64556dae&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64556dae"]])

export default __exports__